import { useContext, useState } from "react";
import StepperComponent from "../../../components/stepper/stepper";
import { BorderedBox } from "../../../components/bordered-box/bordered-box";
import OrganizationUpsertForm, {
  IAddEditProviderModel,
} from "../organization-upsert-form";
import {
  INewOrganizationModel,
  ORGANIZATION_TYPE,
} from "../organizations.model";
import pubSub, { EVENTS } from "../../../config/pubSub";
import { AppConfig } from "../../../context/context";
import { useService } from "../organizations-service";

type IProps = {
  handleClose: () => void;
  handleDone: () => void;
  model: IAddEditProviderModel;
  handleModelChange: (updatedModel: any) => void;
  handleProcessingChange?: (isProcessing: boolean) => void;
};

function getStepContent(
  model: IAddEditProviderModel,
  handleModelChange: (updatedModel: any) => void,
) {
  return {
    0: (
      <>
        <BorderedBox>
          <OrganizationUpsertForm
            model={model}
            handleModelChange={handleModelChange}
          />
        </BorderedBox>
      </>
    ),
  };
}

const AddComponent = (props: IProps) => {
  const { model, handleModelChange } = props;
  const { orgService } = useService();
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  const stepsContent = getStepContent(model, handleModelChange);

  const handleCancel = () => {
    props.handleClose();
  };

  const handleDone = async () => {
    if (!orgService) return;

    props.handleProcessingChange?.(true);
    setIsProcessing(true);

    const newOrganizationModel: INewOrganizationModel = {
      name: model[0].name,
      adminEmail: model[0].email,
      displayName: model[0].displayName,
      type: ORGANIZATION_TYPE.DevPortal,
      locale: model[0].locale
    };

    try {
      await orgService.createOrg(newOrganizationModel);
      pubSub.publish(EVENTS.ADD_ORGANIZATION, newOrganizationModel);
      pubSub.publish(EVENTS.ORGANIZATIONS_LIST);
      props.handleDone();
    } catch (error: any) {
      if (error.response) {
        switch (+error.response.status) {
          case 409:
            pubSub.publish(EVENTS.PP_ERROR_ORGANIZATION_DUP, error);
            break;
          default:
            pubSub.publish(EVENTS.ERROR, "common_error_msg");
        }
      } else {
        pubSub.publish(EVENTS.ERROR, "common_error_msg");
      }
    } finally {
      setIsProcessing(false);
      props.handleProcessingChange?.(false);
    }
  };

  return (
    <>
      <StepperComponent
        isValid={model.isValid}
        stepsContent={stepsContent}
        handleCancel={handleCancel}
        handleDone={handleDone}
        isEdit={false}
        isProcessing={isProcessing}
      />
    </>
  );
};

export default AddComponent;
